import React, { CSSProperties } from 'react';

import closeIcon from 'assets/icons/x.svg';
import './InfoBanner.scoped.scss';

interface Props {
  style?: CSSProperties;
  title?: string;
  content?: string;
  handleBannerVisibility: () => void;
}

const InfoBanner: React.FC<Props> = ({ handleBannerVisibility }) => {
  return (
    <div className="little-banner-container">
      <div className="little-banner-content">
        <p>Demo environment available only between 06:00 - 22:00 Berlin time</p>
      </div>
      <div className="close-button pointer" onClick={handleBannerVisibility}>
        <img src={closeIcon} alt="close-icon" />
      </div>
    </div>
  );
};

export default InfoBanner;
